// extracted by css-extract-rspack-plugin
export default {"container":"SplitPagesContainer_container__rv4gU","titleAndBullets":"SplitPagesContainer_titleAndBullets__v11L1","leftScreen":"SplitPagesContainer_leftScreen__A7bw4"};